import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import {
  ORGANISATION_CONTACTS_RESOURCE,
  CREATE_ORGANISATION_CONTACT_RESOURCE,
} from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateOrganisationContactService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_ORGANISATION_CONTACT_RESOURCE,
      method: 'post',
      request: (organisationId, body, callback, t) => ({
        url: apiRoutes.organisationContacts(organisationId),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: ORGANISATION_CONTACTS_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createContactFailed'),
            onSuccessMessage: t('createContactSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateOrganisationContactService;
